import React from 'react';
import PropTypes from 'prop-types';

import Typography from '../../library/typography/typography';

import './product-swatch-description.scss';

function ProductSwatchDescription(props) {
  const { className = '', color, finish } = props;

  if (!finish && !color) {
    return null;
  }

  return (
    <div
      className={`product-swatch-description ${className}`}
      styleName="container"
    >
      <Typography className="product-swatch-description__label" tag="span">
        {finish ? 'Finish' : 'Color / Finish'}:{' '}
      </Typography>
      <Typography
        className="product-swatch-description__finish"
        styleName="finish"
        tag="span"
        weight="heavy"
      >
        {finish || color}
      </Typography>
    </div>
  );
}

ProductSwatchDescription.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  finish: PropTypes.string
};
export default ProductSwatchDescription;
